<template>
  <!-- 对于分享免登录入口也显示配货专属 TabBar，便于用户在分享页面使用底部导航 -->
  <div id="replenishment-footer" v-if="accountType === 6 || $route.path === '/replenishmentShare'">
    <ul>
      <router-link
        tag="li"
        v-for="item in tabbars"
        :key="item.id"
        :to="item.path"
      >
        <img
          v-if="!item.active"
          class="tabbar-img"
          :src="item.icon"
          alt=""
        />
        <img v-else class="tabbar-img" :src="item.iconActive" alt="" />
        <span>{{ item.text }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TabBarReplenishment",
  watch: {
    $route: {
      handler() {
        console.log(this.$route.path);
        if (this.$route.path === "/replenishment") {
          this.tabbars[0].active = true;
          this.tabbars[1].active = false;
          this.tabbars[2].active = false;
          return;
        }
        if (this.$route.path === "/replenishmentOrder") {
          this.tabbars[0].active = false;
          this.tabbars[1].active = true;
          this.tabbars[2].active = false;
          return;
        }
        if (this.$route.path === "/replenishmentMine") {
          this.tabbars[0].active = false;
          this.tabbars[1].active = false;
          this.tabbars[2].active = true;
          return;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      accountType: 6,
      tabbars: [
        {
          id: 0,
          text: "意向单",
          icon: require("@/assets/image/tab-distribution.png"),
          iconActive: require("@/assets/image/tab-distribution-current.png"),
          path: "/replenishment",
          active: true,
        },
        {
          id: 1,
          text: "已提交意向单",
          icon: require("@/assets/image/tabbar52.png"),
          iconActive: require("@/assets/image/tabbar51.png"),
          path: "/replenishmentOrder",
          active: false,
        },
        {
          id: 2,
          text: "我的",
          icon: require("@/assets/image/tab-mine.png"),
          iconActive: require("@/assets/image/tab-mine-current.png"),
          path: "/replenishmentMine",
          active: false,
        },
      ],
    };
  },
  mounted() {
    this.accountType =
      JSON.parse(sessionStorage.getItem("userInfoXpz"))?.accountType || 6;
  },
};
</script>

<style lang="scss" scoped>
#replenishment-footer {
    width: 100%;
  // height: 1rem;
  padding: .1rem 0 .2rem;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 150;
border-top: .01rem solid #F1F1F1;

}

#replenishment-footer ul {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#replenishment-footer ul li {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

#replenishment-footer ul li span {
  font-size: .2rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #464646;
}

#replenishment-footer ul li img {
  width: .48rem;
  height: .48rem;
}

#replenishment-footer ul .router-link-active {
  span {
    color: #FE2C55;
  }
}
</style>
